define.alias("shared/components/shared/profile-categorization/icons", "media/components/shared/profile-categorization/icons");